/* eslint-disable quotes */
/* eslint-disable function-paren-newline */
/* eslint-disable operator-linebreak */
/* eslint-disable comma-dangle */
/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import moment from 'moment';

const state = {
  automaticCyclingCounters: [],
  trafficSurveyData: [],
  trafficSurveyDataExists: false,
  authorities: [],
  firstRun: true,
  displayError: false,
  geoJson: [],
  errorMsg: '',
  selectedAuthority: 'All',
  selectedNetwork: 'All',
  selectedLocation: null,
  scatterData: [],
  logarithmicData: [],
  logarithmicRanges: [],
  selectedLogRange: {},
  openScatter: false,
  openLog: false,
  loading: false,
  csDataExists: false,
  jmwDataExists: false,
  stransDataExists: false,
  SouthEastTrunkRoadsExists: false,
  SouthWestTrunkRoadsExists: false,
  downloadTrafficSurveyToggle: false,
  networks: {
    Glasgow: {
      bounds: { coords: [55.858333, -4.255069], zoom: 11 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/af7fedef-7a7a-413f-a5c9-46b8eeeabeda',
      apis: [
        {
          label: 'Glasgow City Council',
          provider: 'Glasgow City Council',
          area: 'Glasgow',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/657f6f93-932b-4851-ae21-830b321c185d/latest/urql?',
        },
      ],
    },
    Edinburgh: {
      bounds: { coords: [55.943277, -3.198822], zoom: 12 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/b1f0bd42-e220-465e-99a3-c4f62824f21f',
      apis: [
        {
          label: 'City of Edinburgh Council',
          provider: 'City of Edinburgh Council',
          area: 'Edinburgh',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/7aa487cd-3cd5-405b-850e-1e2ac317816c/latest/urql?',
        },
      ],
    },
    EastDunbartonshire: {
      bounds: { coords: [55.956287, -4.227329], zoom: 12 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/fa2e60c4-73a7-4cb6-91cc-c9ce4a634c59',
      apis: [
        {
          label: 'East Dunbartonshire Council',
          provider: 'East Dunbartonshire Council',
          area: 'East Dunbartonshire',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/439481f9-ed01-4880-8d9b-55bfe12ea932/latest/urql?',
        },
      ],
    },
    'Nah-EileananSiar': {
      bounds: { coords: [55.956287, -4.227329], zoom: 12 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/95dcdb65-ced2-4291-abb2-27209c132115',
      apis: [
        {
          label: 'Comhairle nan Eilean Siar',
          provider: 'Comhairle nan Eilean Siar',
          area: 'Na h-Eileanan Siar',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/76b1d034-058f-4c23-9b33-e3bc11fcf8f2/latest/urql?',
        },
      ],
    },
    Stirling: {
      bounds: { coords: [55.956287, -4.227329], zoom: 12 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/2baff59f-b06f-4424-b6d9-9dc0d8c1d376',
      apis: [
        {
          label: 'Stirling Council',
          provider: 'Stirling Council',
          area: 'Stirling',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/127ececb-bc70-46de-a637-e159b89c6d19/latest/urql?',
        },
      ],
    },
    PerthandKinross: {
      bounds: { coords: [55.956287, -4.227329], zoom: 12 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/16e1662e-c3b4-4b7e-b8b1-04775b7c0737',
      apis: [
        {
          label: 'Perth and Kinross Council',
          provider: 'Perth and Kinross Council',
          area: 'Perth and Kinross',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/840ab46e-93bf-43d9-9a82-0c977302c6c2/latest/urql?',
        },
      ],
    },
    CyclingScotland: {
      bounds: { coords: [56.538287, -3.902893], zoom: 8 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/dd0703b8-4055-400d-9faf-868c34d7574a',
      apis: [
        {
          label: 'Cycling Scotland',
          provider: 'Cycling Scotland',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/5421f510-69b1-4deb-a319-135289598388/latest/urql?',
          area: 'CyclingScotland',
        },
      ],
    },
    JohnMuirWay: {
      bounds: { coords: [56.538287, -3.902893], zoom: 8 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/80b5351e-5280-426d-a8ae-5af79ad2afbb',
      apis: [
        {
          label: 'John Muir Way',
          provider: 'John Muir Way',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/4709d578-f2b6-4584-b8e2-4512c5936f65/latest/urql?',
          area: 'John Muir Way',
        },
      ],
    },
    Sustrans: {
      bounds: { coords: [56.538287, -3.902893], zoom: 8 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/b52df6e9-ae06-4f17-b12e-fac59b1ccca3',
      apis: [
        {
          label: 'Sustrans',
          provider: 'Sustrans',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/3fa86bc7-dde8-4b79-ba78-5873e79ab4d8/latest/urql?',
          area: 'Sustrans',
        },
      ],
    },
    NorthEastTrunkRoads: {
      bounds: { coords: [56.538287, -3.902893], zoom: 8 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/05b83b02-7d57-4b2f-a8ad-209ba1a15ad9',
      apis: [
        {
          label: 'North East Trunk Roads',
          provider: 'North East Trunk Roads',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/91a9d05a-17bc-4c2a-83c8-38f673e86099/latest/urql?',
          area: 'North East Trunk Roads',
        },
      ],
    },
    NorthWestTrunkRoads: {
      bounds: { coords: [56.538287, -3.902893], zoom: 8 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/6edb73cd-360b-41ea-825a-755d858d2440',
      apis: [
        {
          label: 'North West Trunk Roads',
          provider: 'North West Trunk Roads',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/63a2311e-069c-4c6b-88fe-d2a45ceae965/latest/urql?',
          area: 'North West Trunk Roads',
        },
      ],
    },
    SouthEastTrunkRoads: {
      bounds: { coords: [56.538287, -3.902893], zoom: 8 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/38245b62-caae-4717-b86a-c1616d7273c7',
      apis: [
        {
          label: 'South East Trunk Roads',
          provider: 'South East Trunk Roads',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/14c49f20-0a69-4196-b39a-832a8e28ad7b/latest/urql?',
          area: 'South East Trunk Roads',
        },
      ],
    },
    SouthWestTrunkRoads: {
      bounds: { coords: [56.538287, -3.902893], zoom: 8 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/deef0957-3a88-45df-b0b5-61c83d3816dc',
      apis: [
        {
          label: 'South West Trunk Roads',
          provider: 'South West Trunk Roads',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/bd984932-6659-4775-8315-c550a1125852/latest/urql?',
          area: 'South West Trunk Roads',
        },
      ],
    },
    Highland: {
      bounds: { coords: [56.538287, -3.902893], zoom: 8 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/da632de6-499b-427d-a15d-94c75d381249',
      apis: [
        {
          label: 'The Highland Council',
          provider: 'The Highland Council',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/c762c71a-7366-44ba-8828-90f473295f44/latest/urql?',
          area: 'Highland',
        },
      ],
    },
    Aberdeen: {
      bounds: { coords: [56.538287, -3.902893], zoom: 8 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/c3248da7-823b-40e7-ae5c-9b33a4ab7f16',
      apis: [
        {
          label: 'Aberdeen City Council',
          provider: 'Aberdeen City Council',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/d0717679-21fb-4274-a9d3-f973cfb5b7ff/latest/urql?',
          area: 'Aberdeen',
        },
      ],
    },
    Aberdeenshire: {
      bounds: { coords: [57.28614, -2.609981], zoom: 8 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/2f91aa68-aebf-4d7b-bea6-9342995848cc',
      apis: [
        {
          label: 'Aberdeenshire Council',
          provider: 'Aberdeenshire Council',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/d7e5da9d-e676-4e5d-8959-b5a0a59ba18c/latest/urql?',
          area: 'Aberdeenshire',
        },
      ],
    },
    NorthAyrshire: {
      bounds: { coords: [56.538287, -3.902893], zoom: 8 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/0bbe839b-6eb0-427f-9da0-105fc91cad59',
      apis: [
        {
          label: 'North Ayrshire Council',
          provider: 'North Ayrshire Council',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/1b1f46df-8b37-48fb-90fa-9f464bb8f30a/latest/urql?',
          area: 'North Ayrshire',
        },
      ],
    },
    SouthLanarkshire: {
      bounds: { coords: [56.538287, -3.902893], zoom: 8 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/aa516804-3c9a-459b-a28c-75e80ef39e0f',
      apis: [
        {
          label: 'South Lanarkshire Council',
          provider: 'South Lanarkshire Council',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/1751a710-7f65-4fde-ad6a-9fb1ba3d19bf/latest/urql?',
          area: 'South Lanarkshire',
        },
      ],
    },
    EastAyrshire: {
      bounds: { coords: [55.508959, -4.275796], zoom: 8 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/4469c4a8-51f0-4e53-8ee9-681b68403d41',
      apis: [
        {
          label: 'East Ayrshire Council',
          provider: 'East Ayrshire Council',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/419c8ce9-9297-4b38-9cbd-341f0611b209/latest/urql?',
          area: 'East Ayrshire',
        },
      ],
    },
    SouthAyrshire: {
      bounds: { coords: [55.257017, -4.693621], zoom: 8 },
      dataset:
        'https://usmart.io/org/cyclingscotland/discovery/discovery-view-detail/da45239d-666e-40fb-93ee-3ca411c49146',
      apis: [
        {
          label: 'South Ayrshire Council',
          provider: 'South Ayrshire Council',
          url:
            'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/3ab8e1e7-87cb-4674-98e6-2f8b0c6fa7ac/latest/urql?',
          area: 'South Ayrshire',
        },
      ],
    },
    // Clackmannanshire: {
    //   bounds: { coords: [56.150231, -3.741173], zoom: 8 },
    //   dataset: '',
    //   apis: [
    //     {
    //       label: 'Clackmannanshire',
    //       provider: 'Clackmannanshire',
    //       url: '',
    //       area: 'Clackmannanshire',
    //     },
    //   ],
    // },
  },
};
// headers required for live requests

const headers = {
  withCredentials: false,
  // live
  'api-key-id': process.env.VUE_APP_ID,
  'api-key-secret': process.env.VUE_APP_SECRET,
  // staging
  // "api-key-id": "fb6d2e42-f0c4-47cd-b843-7c36a1658885",
  // "api-key-secret": "d65ca26238281ed339e4adcb3e0d82d5ff15062dfd947d4e173e4de655509648"
};

// helper functions

function filterRequiredApis(stateTree, getters) {
  const authority = stateTree.selectedAuthority.replace(/\s/g, '');
  const network = stateTree.selectedNetwork.replace(/\s/g, '');
  const keys = Object.keys(stateTree.networks);
  let filtered = keys;
  const onlyNetworksAvailable = [...getters.fetchNetworks]
    .filter((key) => key.area && key.area !== null)
    .map((key) => key.area.replace(/\s+/g, ''));
  if (authority !== 'All') {
    filtered = keys.filter(
      (key) =>
        key === 'CyclingScotland' ||
        key === 'JohnMuirWay' ||
        key === 'Sustrans' ||
        key === 'NorthEastTrunkRoads' ||
        key === 'NorthWestTrunkRoads' ||
        key === 'SouthEastTrunkRoads' ||
        key === 'SouthWestTrunkRoads' ||
        authority === key,
    );
    filtered = keys.filter((key) => onlyNetworksAvailable.includes(key));
  }
  if (network !== 'All') {
    filtered = keys.filter(
      (key) =>
        network.includes(key) ||
        (key === 'Nah-EileananSiar' && network === 'ComhairlenanEileanSiar'),
    );
  }
  let apis = [];
  filtered.forEach((key) => {
    if (authority !== 'All' && network === 'All') {
      // selected authority only
      apis = apis.concat(
        stateTree.networks[key].apis
          .filter((api) => api.label !== 'All')
          .map((api) => ({ url: api.url, label: api.label, provider: api.provider })),
      );
    } else if (
      (authority === 'All' && network !== 'All') ||
      (authority !== 'All' && network !== 'All')
    ) {
      // return selection of network
      if (
        stateTree.networks[key] &&
        (network !== 'CyclingScotland' ||
          network !== 'JohnMuirWay' ||
          network !== 'Sustrans' ||
          network !== 'NorthEastTrunkRoads' ||
          network !== 'NorthWestTrunkRoads' ||
          network !== 'SouthEastTrunkRoads' ||
          network !== 'SouthWestTrunkRoads')
      ) {
        apis = stateTree.networks[key].apis
          .filter((api) => api.label !== 'All')
          .map((api) => ({
            url: api.url,
            label: api.label,
            provider: api.provider,
          }));
      } else if (network === 'CyclingScotland') {
        apis = stateTree.networks.CyclingScotland.apis.map((api) => ({
          url: api.url,
          label: api.label,
          provider: api.provider,
        }));
      } else if (network === 'JohnMuirWay') {
        apis = stateTree.networks.JohnMuirWay.apis.map((api) => ({
          url: api.url,
          label: api.label,
          provider: api.provider,
        }));
      } else if (network === 'Sustrans') {
        apis = stateTree.networks.Sustrans.apis.map((api) => ({
          url: api.url,
          label: api.label,
          provider: api.provider,
        }));
      } else if (network === 'NorthEastTrunkRoads') {
        apis = stateTree.networks.NorthEastTrunkRoads.apis.map((api) => ({
          url: api.url,
          label: api.label,
          provider: api.provider,
        }));
      } else if (network === 'NorthWestTrunkRoads') {
        apis = stateTree.networks.NorthWestTrunkRoads.apis.map((api) => ({
          url: api.url,
          label: api.label,
          provider: api.provider,
        }));
      } else if (network === 'SouthEastTrunkRoads') {
        apis = stateTree.networks.SouthEastTrunkRoads.apis.map((api) => ({
          url: api.url,
          label: api.label,
          provider: api.provider,
        }));
      } else if (network === 'SouthWestTrunkRoads') {
        apis = stateTree.networks.SouthWestTrunkRoads.apis.map((api) => ({
          url: api.url,
          label: api.label,
          provider: api.provider,
        }));
      } else {
        // no resources
        apis = [];
      }
    } else {
      // used for all + all
      apis = apis.concat(
        stateTree.networks[key].apis.map((api) => ({
          url: api.url,
          label: api.label,
          provider: api.provider,
        })),
      );
      apis = apis.filter((api) => api.label !== 'All');
    }
  });
  return apis;
}

function downloadItem(url) {
  return axios.get(url, { headers, responseType: 'blob' });
}

// end of helper functions

const getters = {
  fetchAutomaticCyclingCounters(stateTree) {
    // return all data to be plotted
    return stateTree.automaticCyclingCounters;
  },
  fetchTrafficSurveys(stateTree) {
    // return all data to be plotted
    return stateTree.trafficSurveyData;
  },
  fetchLocalAuthorities(stateTree) {
    // filter counters and return only distinct authorities
    return stateTree.authorities;
  },
  getBounds(stateTree) {
    const authority = stateTree.selectedAuthority;
    const network = stateTree.selectedNetwork.replace(/\s/g, '');
    let area = null;
    if (network && network !== 'All') {
      const keys = Object.keys(stateTree.networks);
      const filteredKey = keys.filter(
        (key) =>
          network.includes(key) ||
          (key === 'Nah-EileananSiar' && network === 'ComhairlenanEileanSiar'),
      );
      const apis = stateTree.networks[filteredKey[0]].apis.filter((api) => api.label !== 'All');
      area = apis[0].area;
    }
    const groups = [
      {
        areas: ['Highland', 'Na h-Eileanan Siar'],
        coords: [57.575174, -6.724614],
        zoom: 8,
      },
      { areas: ['John Muir Way'], coords: [55.921927, -3.640663], zoom: 10 },
      { areas: ['Sustrans'], coords: [56.538287, -3.902893], zoom: 8 },
      {
        areas: ['Argyll and Bute', 'Inverclyde', 'North Ayrshire'],
        coords: [55.9892758, -6.3979092],
        zoom: 8,
      },
      {
        areas: ['Aberdeen', 'Aberseenshire', 'Moray'],
        coords: [57.2281168, -3.2995392],
        zoom: 9,
      },
      {
        areas: [
          'Perth and Kinross',
          'Stirling',
          'Fife',
          'Angus',
          'Clackmannanshire',
          'Dundee City',
        ],
        coords: [56.2885589, -3.5793434],
        zoom: 9,
      },
      {
        areas: ['Edinburgh'],
        coords: [55.9412845, -3.2755496],
        zoom: 11,
      },
      {
        areas: [
          'Glasgow',
          'Glasgow City',
          'West Dunbartonshire',
          'East Dunbartonshire',
          'Renfrewshire',
          'East Renfrewshire',
          'South Lanarkshire',
        ],
        coords: [55.8057948, -4.4288751],
        zoom: 10,
      },
      {
        areas: ['Dumfries and Galloway', 'South Ayrshire', 'East Ayrshire'],
        coords: [55.1723998, -4.3999114],
        zoom: 9,
      },
      {
        areas: ['Shetland', 'Orkney'],
        coords: [60.1801717, -2.3795331],
        zoom: 7,
      },
      {
        areas: ['North Lanarkshire', 'Falkirk', 'West Lothian'],
        coords: [55.9097418, -3.8549773],
        zoom: 11,
      },
      {
        areas: ['All'],
        coords: [56.538287, -3.902893],
        zoom: 8,
      },
    ];
    let filtered;
    if (network && network !== 'All' && authority && authority !== 'All') {
      filtered = groups.filter((group) => group.areas.includes(authority));
    } else if (network && network !== 'All') {
      filtered = groups.filter((group) => group.areas.includes(area));
    } else {
      filtered = groups.filter((group) => group.areas.includes(authority));
    }
    // return default
    return filtered[0];
  },
  getDataLink(stateTree) {
    const { provider } = stateTree.selectedLocation;
    const joined = provider.replace(/\s/g, '');
    const keys = Object.keys(stateTree.networks);
    const filteredKeys = keys.filter((key) => joined.includes(key));
    const accessKey =
      filteredKeys.length > 1 ? filteredKeys[filteredKeys.length - 1] : filteredKeys[0];
    if (stateTree.networks[accessKey]) return stateTree.networks[accessKey].dataset;
    return stateTree.networks.CyclingScotland.dataset;
  },
  getGeoJson(stateTree) {
    return stateTree.geoJson;
  },
  fetchNetworks(stateTree) {
    // filter counters and return only distinct networks
    let options = [];
    // should always have an all option

    if (stateTree.selectedAuthority !== 'All') {
      // remove space from chosen authority
      const authorityName = stateTree.selectedAuthority.replace(/\s/g, '');
      const authority = stateTree.networks[authorityName];
      if (authority) options = authority.apis;
      // check cycling scotland for data and if it exists add it as an option.
      // NEW If traffic survey data exists we need cycling scotland as an option as well
      if (stateTree.csDataExists || stateTree.trafficSurveyDataExists) {
        options = options.concat(stateTree.networks.CyclingScotland.apis);
      }
      if (stateTree.jmwDataExists) {
        options = options.concat(stateTree.networks.JohnMuirWay.apis);
      }
      if (stateTree.stransDataExists) {
        options = options.concat(stateTree.networks.Sustrans.apis);
      }
      if (stateTree.NorthEastTrunkRoadsDataExists) {
        options = options.concat(stateTree.networks.NorthEastTrunkRoads.apis);
      }
      if (stateTree.NorthWestTrunkRoadsDataExists) {
        options = options.concat(stateTree.networks.NorthWestTrunkRoads.apis);
      }
      if (stateTree.SouthEastTrunkRoadsExists) {
        options = options.concat(stateTree.networks.SouthEastTrunkRoads.apis);
      }
      if (stateTree.SouthWestTrunkRoadsExists) {
        options = options.concat(stateTree.networks.SouthWestTrunkRoads.apis);
      }
      options.sort((a, b) => a.label.localeCompare(b.label));
      options.unshift({ label: 'All' });
      return options;
    }
    if (stateTree.selectedAuthority === 'All') {
      const keys = Object.keys(stateTree.networks);
      keys.forEach((key) => {
        options.push(stateTree.networks[key].apis);
      });
      options.sort((a, b) => a[0].label.localeCompare(b[0].label));
      options.unshift({ label: 'All' });
      return options.flat();
    }
    return options;
  },
  fetchScatterData(stateTree) {
    return stateTree.scatterData
      .map((result) => ({
        value: result.count,
        date: new Date(result.startTime),
      }))
      .sort((a, b) => new Date(a.date) - new Date(b.date));
  },
  fetchlogarithmicData(stateTree) {
    const data = stateTree.logarithmicData
      .map((result) => {
        let CyclistValue = result.Cyclist;
        if (CyclistValue <= 0) CyclistValue = 0.1;
        let PedestrianValue = result.Pedestrian;
        if (PedestrianValue <= 0) PedestrianValue = 0.1;
        let busValue = result['Bus/Coach'];
        if (busValue <= 0) busValue = 0.1;
        let carValue = result['Car/Taxi'];
        if (carValue <= 0) carValue = 0.1;
        let mCycleValue = result['M/Cycle'];
        if (mCycleValue <= 0) mCycleValue = 0.1;
        let goodsVehicleValue = result['Goods Vehicle'];
        if (goodsVehicleValue <= 0) goodsVehicleValue = 0.1;
        const results = {
          Cyclist: CyclistValue,
          Bus: busValue,
          Car: carValue,
          MotorCycle: mCycleValue,
          Goods: goodsVehicleValue,
          Pedestrian: PedestrianValue,
          date: new Date(result.StartDateTime),
        };
        return results;
      })
      .sort((a, b) => new Date(a.date) - new Date(b.date));
    return data;
  },
  getScatterToggle(stateTree) {
    return stateTree.openScatter;
  },
  getSelectedLocation(stateTree) {
    return stateTree.selectedLocation;
  },
  getTrafficSurveyToggle(stateTree) {
    return stateTree.downloadTrafficSurveyToggle;
  },
  getLogToggle(stateTree) {
    return stateTree.openLog;
  },
  getErrorMessage(stateTree) {
    return stateTree.errorMsg;
  },
  checkLoading(stateTree) {
    return stateTree.loading;
  },
  getLogarithmicRanges(stateTree) {
    return stateTree.logarithmicRanges;
  },
};

const actions = {
  async requestAutomaticCyclingCounters({ commit, state: stateTree, getters: get }, params) {
    commit('toggleLoading', true);
    state.jmwDataExists = false;
    state.stransDataExists = false;
    state.NorthEastTrunkRoadsExists = false;
    state.NorthWestTrunkRoadsExists = false;
    state.SouthEastTrunkRoadsExists = false;
    state.SouthWestTrunkRoadsExists = false;
    const promises = [];
    // need to check if csdataexists before we can use it ;to filter required apis for other filters
    if (state.selectedAuthority !== 'All') {
      const johnMuirWayssAPI = state.networks.JohnMuirWay.apis[0].url;
      const sustransAPI = state.networks.Sustrans.apis[0].url;
      const activeTravelsAPI = state.networks.CyclingScotland.apis[0].url;
      const NorthEastTrunkRoadsScotlandAPI = state.networks.NorthEastTrunkRoads.apis[0].url;
      const NorthWestTrunkRoadsScotlandAPI = state.networks.NorthWestTrunkRoads.apis[0].url;
      const SouthEastTrunkRoadsScotlandAPI = state.networks.SouthEastTrunkRoads.apis[0].url;
      const SouthWestTrunkRoadsScotlandAPI = state.networks.SouthWestTrunkRoads.apis[0].url;
      const cyclingScotlandDataExists = await axios.get(
        `${activeTravelsAPI}limit(1)&eq(area,${state.selectedAuthority})`,
        { headers },
      );
      const johnMuirWaydDataExists = await axios.get(
        `${johnMuirWayssAPI}limit(1)&eq(area,${state.selectedAuthority})`,
        { headers },
      );
      const sustransDataExists = await axios.get(
        `${sustransAPI}limit(1)&eq(area,${state.selectedAuthority})`,
        { headers },
      );
      const SouthEastTrunkRoadsDataExists = await axios.get(
        `${SouthEastTrunkRoadsScotlandAPI}limit(1)&eq(area,${state.selectedAuthority})`,
        { headers },
      );
      const SouthWestTrunkRoadsDataExists = await axios.get(
        `${SouthWestTrunkRoadsScotlandAPI}limit(1)&eq(area,${state.selectedAuthority})`,
        { headers },
      );
      const NorthEastTrunkRoadsDataExists = await axios.get(
        `${NorthEastTrunkRoadsScotlandAPI}limit(1)&eq(area,${state.selectedAuthority})`,
        { headers },
      );
      const NorthWestTrunkRoadsDataExists = await axios.get(
        `${NorthWestTrunkRoadsScotlandAPI}limit(1)&eq(area,${state.selectedAuthority})`,
        { headers },
      );
      state.csDataExists = cyclingScotlandDataExists.data.length > 0;
      state.jmwDataExists = johnMuirWaydDataExists.data.length > 0;
      state.stransDataExists = sustransDataExists.data.length > 0;
      state.NorthEastTrunkRoadsDataExists = NorthEastTrunkRoadsDataExists.data.length > 0;
      state.NorthWestTrunkRoadsDataExists = NorthWestTrunkRoadsDataExists.data.length > 0;
      state.SouthEastTrunkRoadsExists = SouthEastTrunkRoadsDataExists.data.length > 0;
      state.SouthWestTrunkRoadsExists = SouthWestTrunkRoadsDataExists.data.length > 0;
    }
    const apis = filterRequiredApis(stateTree, get);
    apis.forEach((api) => {
      let query = api.url;
      if (api.url.length !== 0) {
        if (params) {
          for (let i = 0; i < params.operators.length; i += 1) {
            query += `&${params.operators[i]}`;
          }
        }
        promises.push(axios.get(query, { headers }));
      }
    });
    Promise.all(promises)
      .then((values) => {
        const data = values.map((value) => value.data);
        const flatten = data.flat();
        commit('updateAutomaticCyclingCounters', flatten);
        commit('toggleLoading', false);
      })
      .catch((e) => {
        console.error(e);
        commit('toggleLoading', false);
        commit('setError', {
          error: 'Resources are unavailable at this time. Please try again or contact USMART help.',
        });
      });
  },
  async requestTrafficSurveyData({ commit, state: stateTree }, params) {
    commit('toggleLoading', true);
    let query =
      'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/12da6df6-7b38-4907-8f00-76a6c260b197/latest/urql?';
    if (params) {
      for (let i = 0; i < params.operators.length; i += 1) {
        if (i === 0) {
          query += params.operators[i];
        } else {
          query += `&${params.operators[i]}`;
        }
      }
    }
    const response = await axios.get(query, {
      headers,
    });
    const { data } = response;
    stateTree.trafficSurveyDataExists = !!data[0].hits;
    if (stateTree.selectedNetwork === 'All' || stateTree.selectedNetwork === 'Cycling Scotland') {
      commit('updateTrafficSurveyData', data);
      commit('toggleLoading', false);
    } else {
      commit('updateTrafficSurveyData', []);
      commit('toggleLoading', false);
    }
  },
  async requestGeoJson({ commit }) {
    commit('toggleLoading', true);
    const query = 'https://martinjc.github.io/UK-GeoJSON/json/sco/topo_lad.json';
    const response = await axios.get(query);
    commit('storeGeoJson', response.data);
    commit('toggleLoading', false);
  },
  async requestScatterGraphData({ state: stateTree, commit }, params) {
    if (stateTree.openLog) {
      commit('setError', { error: 'Please close the logarithmic graph first' });
      commit('toggleLoading', false);
    } else {
      commit('toggleLoading', true);
      if (params) {
        let apis = [];
        const keys = Object.keys(stateTree.networks);
        for (let index = 0; index < keys.length; index += 1) {
          apis = apis.concat(stateTree.networks[keys[index]].apis);
        }
        const filteredApi = apis.filter((current) => current.provider === params.provider).pop();
        let query = filteredApi.url;
        const lon = params.longitude;
        const lat = params.latitude;
        const timeOfResults = moment()
          .subtract(2, 'years')
          .format('YYYY-MM-DD');
        query += `limit(-1)&sort(+startTime)&eq(longitude,${lon})&eq(latitude,${lat})&ge(startTime,${timeOfResults})`;

        const response = await axios.get(query, {
          headers,
        });
        const { data } = response;
        commit('toggleScatter', true);
        commit('updateScatterData', data);
        commit('updateLocation', params);
      }
      commit('toggleLoading', false);
    }
  },
  async requestLogarithmicGraphData({ state: stateTree, commit }, params) {
    if (stateTree.openScatter) {
      commit('setError', { error: 'Please close the scatter graph first' });
      commit('toggleLoading', false);
    } else {
      commit('toggleLoading', true);
      // request log data check for point and setup dropdown options
      const api =
        'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/12da6df6-7b38-4907-8f00-76a6c260b197/latest/urql?';

      // initialise the first set of dates
      if (params) {
        const lon = params.Longitude;
        const lat = params.Latitude;
        let query = `${api}limit(-1)&sort(+StartDateTime)&eq(Longitude,${lon})&eq(Latitude,${lat})&date_histogram(StartDateTime,day,value_count(StartDateTime))`;
        let response = await axios.get(query, {
          headers,
        });
        let { data } = response;
        const timestampResults = Object.entries(data[0]);
        const availableDates = timestampResults
          .filter(([, value]) => {
            const key = Object.keys(value);
            return value[key] > 0;
          })
          .map(([key]) =>
            moment
              .unix(key / 1000)
              .utc()
              .format('YYYY-MM-DD'),
          );
        const ranges = availableDates.reduce((result, currentvalue, currentIndex, array) => {
          if (currentIndex % 2 === 0) {
            result.push(array.slice(currentIndex, currentIndex + 2));
          }
          return result;
        }, []);
        query = `${api}limit(-1)&sort(+StartDateTime)&eq(Longitude,${lon})&eq(Latitude,${lat})&ge(StartDateTime,${ranges[0][0]})&le(StartDateTime,${ranges[0][1]})`;
        response = await axios.get(query, {
          headers,
        });
        data = response.data;
        commit('toggleLog', true);
        commit('updateLogData', data);
        commit('updateLocation', params);
        commit('updateLogRanges', ranges);
        commit('toggleLoading', false);
      } else {
        commit('setError', { error: 'Logarithmic Data: There was no parameters for the request' });
        commit('toggleLoading', false);
      }
    }
  },
  async requestUpdateToLogData({ state: stateTree, commit }, params) {
    commit('toggleLoading', true);
    const api =
      'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/12da6df6-7b38-4907-8f00-76a6c260b197/latest/urql?';
    const lat = stateTree.selectedLocation.Latitude;
    const lng = stateTree.selectedLocation.Longitude;
    const query = `${api}limit(-1)&sort(+StartDateTime)&eq(Longitude,${lng})&eq(Latitude,${lat})&ge(StartDateTime,${params.from})&le(StartDateTime,${params.to})`;
    const response = await axios.get(query, {
      headers,
    });
    const { data } = response;
    commit('updateLogData', data);
    commit('toggleLoading', false);
  },
  async requestDownloads({ state: stateTree, getters: get }, params) {
    return new Promise((resolve, reject) => {
      const promises = [];
      const apis = filterRequiredApis(stateTree, get);
      const filenameLabeling = [];
      apis.forEach((api, index) => {
        let query = api.url;
        if (stateTree.selectedLocation) {
          filenameLabeling.push(
            `${api.provider}_${state.selectedAuthority}_${stateTree.selectedLocation.location}_${params.startTime}_${params.endTime}`,
          );
        } else {
          filenameLabeling.push(
            `${api.provider}_${state.selectedAuthority}_${params.startTime}_${params.endTime}`,
          );
        }
        for (let i = 0; i < params.operators.length; i += 1) {
          query += `&${params.operators[i]}`;
        }
        promises.push(downloadItem(query, index));
      });
      if (promises.length > 0) {
        Promise.all(promises).then((responses) => {
          resolve(
            responses.map((resp, index) => ({
              data: resp.data,
              filename: filenameLabeling[index],
            })),
          );
        });
      } else {
        reject(
          new Error(
            'Counter data is currently not available in this area. Please select another area',
          ),
        );
      }
    });
  },
  async singularDownload({ state: stateTree }, params) {
    let api = '';
    let filename = 'default';
    let { area, provider } = stateTree.selectedLocation;

    filename = `${provider}_${area}_${stateTree.selectedLocation.location}_${params.startTime}_${params.endTime}`;
    if (
      provider === 'John Muir Way' ||
      provider === 'Cycling Scotland' ||
      provider === 'North East Trunk Roads' ||
      provider === 'South East Trunk Roads' ||
      provider === 'South East Trunk Roads' ||
      provider === 'Sustrans'
    ) {
      provider = provider.replace(/\s/g, '');
      api = stateTree.networks[provider].apis[0].url;
    } else {
      area = area.replace(/\s/g, '');
      const removeAllOption = stateTree.networks[area].apis.filter(
        (option) => option.label !== 'All',
      );
      api = removeAllOption[0].url;
    }
    for (let i = 0; i < params.operators.length; i += 1) {
      api += `&${params.operators[i]}`;
    }
    const response = await downloadItem(api);
    const fileRes = { data: response.data, filename };
    return [fileRes];
  },
  async requestTrafficSurveyDownload({ state: stateTree }, params) {
    let query =
      'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/12da6df6-7b38-4907-8f00-76a6c260b197/latest/urql?';
    for (let i = 0; i < params.operators.length; i += 1) {
      query += `&${params.operators[i]}`;
    }
    if (stateTree.selectedAuthority && stateTree.selectedAuthority !== 'All') {
      query += `&eq(Area,${stateTree.selectedAuthority})`;
    }
    const response = await downloadItem(query);
    // should return axios ( promise )
    return response;
  },
};

const mutations = {
  updateAutomaticCyclingCounters(stateTree, payload) {
    if (payload.length <= 0) {
      // fire off message about no data
      // stateTree.displayError = true;
      stateTree.automaticCyclingCounters = [];
      // stateTree.selectedAuthority = 'All';
      // stateTree.selectedNetwork = 'All';
    } else if (payload && payload[0].hits && payload[0].hits._source) {
      stateTree.automaticCyclingCounters = payload.map((row) => row.hits._source);
    } else {
      console.error('Cannot read any hits from payload: ', payload);
      // fire off message about no data
      stateTree.errorMsg = "There was an issue with the API you're requesting data from";
      stateTree.displayError = true;
      stateTree.automaticCyclingCounters = [];
      // stateTree.selectedAuthority = 'All';
      // stateTree.selectedNetwork = 'All';
    }
  },
  updateTrafficSurveyData(stateTree, payload) {
    if (payload && payload[0]) {
      if (payload[0].hits && payload[0].hits._source) {
        // set cycling scotland data to true as we have traffic surveys for the area
        stateTree.trafficSurveyData = payload.map((row) => row.hits._source);
        if (stateTree.firstRun) {
          const mapped = stateTree.trafficSurveyData.map((counter) => counter.Area);
          const filtered = mapped.filter((v, i, a) => a.indexOf(v) === i);
          filtered.sort();
          filtered.unshift('All');
          stateTree.authorities = filtered;
          stateTree.firstRun = false;
        }
      }
    } else {
      stateTree.trafficSurveyData = [];
    }
  },
  updateScatterData(stateTree, payload) {
    if (payload) {
      stateTree.scatterData = payload.map((row) => row);
    }
  },
  updateLogData(stateTree, payload) {
    if (payload) {
      stateTree.logarithmicData = payload.map((row) => row);
    }
  },
  updateLogRanges(stateTree, payload) {
    if (payload) {
      stateTree.logarithmicRanges = payload
        .map((range) => ({ ...range }))
        .map((range) => ({ from: range[0], to: range[1] }))
        .reverse();
      const [first] = stateTree.logarithmicRanges;
      stateTree.selectedLogRange = first;
    }
  },
  toggleScatter(stateTree, payload) {
    stateTree.openScatter = payload;
    // reset location due to scatter being closed
    if (!payload) stateTree.selectedLocation = null;
  },
  setDownloadTrafficSurveyToggle(stateTree, payload) {
    stateTree.downloadTrafficSurveyToggle = payload;
  },
  toggleLog(stateTree, payload) {
    stateTree.openLog = payload;
    // reset location due to scatter being closed
    if (!payload) stateTree.selectedLocation = null;
  },
  setAuthority(stateTree, payload) {
    stateTree.selectedAuthority = payload;
  },
  setNetwork(stateTree, payload) {
    stateTree.selectedNetwork = payload;
  },
  setLogRange(stateTree, payload) {
    stateTree.selectedLogRange = payload;
  },
  closeErrorModal(stateTree, payload) {
    stateTree.displayError = payload;
  },
  toggleLoading(stateTree, payload) {
    stateTree.loading = payload;
  },
  setError(stateTree, payload) {
    stateTree.errorMsg = payload.error;
    stateTree.displayError = true;
  },
  updateLocation(stateTree, payload) {
    stateTree.selectedLocation = payload;
  },
  storeGeoJson(stateTree, payload) {
    stateTree.geoJson = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
